module.exports = __webpack_public_path__ + "static/media/depression.3aa0eeec.png";